import { SignUp } from '@clerk/clerk-react';

const clerkAppearance = {
  variables: {
    colorPrimary: '#6366f1',
    colorBackground: '#12151c',
    colorInputBackground: '#1a1f2e',
    colorInputText: '#e2e8f0',
    colorText: '#e2e8f0',
    colorTextSecondary: '#94a3b8',
    colorNeutral: '#94a3b8',
    borderRadius: '8px',
    fontFamily: "'DM Sans', system-ui, sans-serif",
  },
  elements: {
    card: {
      background: '#12151c',
      border: '1px solid #1e2535',
      boxShadow: '0 4px 24px rgba(0,0,0,0.4)',
    },
    headerTitle: {
      color: '#e2e8f0',
      fontFamily: "'Playfair Display', Georgia, serif",
    },
    headerSubtitle: { color: '#94a3b8' },
    formFieldInput: {
      background: '#1a1f2e',
      border: '1px solid #2a3045',
      color: '#e2e8f0',
    },
    formButtonPrimary: {
      background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)',
      color: '#fff',
    },
    footerAction: { color: '#94a3b8' },
    footerActionLink: { color: '#6366f1' },
    identityPreviewText: { color: '#e2e8f0' },
    formFieldLabel: { color: '#94a3b8' },
    dividerLine: { background: '#1e2535' },
    dividerText: { color: '#64748b' },
    socialButtonsBlockButton: {
      background: '#1a1f2e',
      border: '1px solid #2a3045',
      color: '#e2e8f0',
    },
    socialButtonsBlockButtonText: { color: '#e2e8f0' },
  },
};

export default function SignUpPage() {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#0a0c10',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '2rem',
      }}
    >
      {/* Wordmark */}
      <div style={{ textAlign: 'center' }}>
        <h1
          style={{
            fontFamily: "'Playfair Display', Georgia, serif",
            fontSize: '2rem',
            fontWeight: 700,
            color: '#6366f1',
            letterSpacing: '-0.01em',
          }}
        >
          ServeGrace
        </h1>
        <p
          style={{
            fontFamily: "'DM Sans', system-ui, sans-serif",
            color: '#64748b',
            fontSize: '0.875rem',
            marginTop: '0.25rem',
          }}
        >
          Customer service with grace.
        </p>
      </div>

      {/* Clerk SignUp */}
      <SignUp
        routing="path"
        path="/sign-up"
        signInUrl="/sign-in"
        appearance={clerkAppearance}
      />
    </div>
  );
}
